import { render, staticRenderFns } from "./ResendActivationEmail.vue?vue&type=template&id=5d8b1f46&scoped=true"
import script from "./ResendActivationEmail.vue?vue&type=script&lang=js"
export * from "./ResendActivationEmail.vue?vue&type=script&lang=js"
import style0 from "./ResendActivationEmail.vue?vue&type=style&index=0&id=5d8b1f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8b1f46",
  null
  
)

export default component.exports